import { useEffect, useState, type ReactNode } from 'react';
import { CaretDownNew } from '@hungryroot/icons';
import { Dimension, IconButton } from '@hungryroot/ramen';
import styles from './Header.module.css';

interface Props {
  onBackButtonClick?: () => void;
  children?: ReactNode;
}

export const LOGO_PATH = `/public/img/logos/hr-logo-smile-red.svg`;

const HEADER_HEIGHT = 24;

export function Header({ children, onBackButtonClick }: Props) {
  const [isShadowShown, setIsShadowShown] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY =
        window.scrollY || document.documentElement.scrollTop;

      if (currentScrollY > HEADER_HEIGHT) {
        setIsShadowShown(true);
      } else {
        setIsShadowShown(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <Dimension level={isShadowShown ? 'two' : 'none'} className={styles.header}>
      {onBackButtonClick && (
        <IconButton
          icon={<CaretDownNew />}
          testid="back-button"
          style="muted"
          size="medium"
          prominence="tertiary"
          ariaLabel="plan back button"
          onClick={onBackButtonClick}
          className={styles.back}
        />
      )}
      <nav className={styles.top}>
        <img className={styles.logo} alt="Hungryroot logo" src={LOGO_PATH} />
      </nav>
      {children && <div className={styles.children}>{children}</div>}
    </Dimension>
  );
}
